import React from "react";
import Icon from "./Icon";

// Icons/Core/arrow-go-back-line
function Checked(props) {
  const svgPathDParameter = "M5.828 7l2.536 2.536L6.95 10.95 2 6l4.95-4.95 1.414 1.414L5.828 5H13a8 8 0 1 1 0 16H4v-2h9a6 6 0 1 0 0-12H5.828z";
  
  return (<Icon {...props} svgPathDParameter={svgPathDParameter} />);
}

export default Checked;
